import React, { FC, PropsWithChildren } from 'react';

import { ScrollView } from '@rbilabs/universal-components';

import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { staticLocation } from 'state/location';
import { routes } from 'utils/routing';

import { IContainerProps } from './types';

const defaultScrollViewProps = {};
const scrollViewPropsFullHeight = {
  contentContainerStyle: {
    flex: 1,
  },
};

export const ScrollContainer: FC<PropsWithChildren<IContainerProps>> = ({
  children,
  scrollRef,
}) => {
  const isDesktop = useIsDesktopBreakpoint();

  // FIXME: BKPE-1489: issue with scroll views
  const pathname = staticLocation.current.pathname;
  const hasFullHeightContent =
    routes.base === pathname ||
    pathname.includes(routes.orderConfirmation) ||
    pathname.includes(routes.storeLocator);
  const scrollViewProps = hasFullHeightContent ? scrollViewPropsFullHeight : defaultScrollViewProps;

  return (
    <ScrollView
      ref={scrollRef}
      showsVerticalScrollIndicator={isDesktop}
      nativeID="scroll-container"
      {...scrollViewProps}
    >
      {children}
    </ScrollView>
  );
};
